/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListSchedulesGlobals = {
  /**
   * Specify an API version.
   *
   * @remarks
   *
   * API versioning follows the format `vYYYY.QQ.BB`, where
   *   - `YYYY` is the year
   *   - `QQ` is the two-digit month for the first month of the quarter (e.g., 01, 04, 07, 10)
   *   - `BB` is the build number, starting at `.01`, for subsequent builds in the same quarter.
   *     - For example, `v2024.01.00` is the initial release of the first quarter of 2024.
   *
   * The `latest` version represents the most recent development state. It may include breaking changes and should be treated as a beta release.
   * When no version is specified, the API defaults to `v2024.01.00`.
   */
  xMoovVersion?: string | undefined;
};

export const Hydrate = {
  Accounts: "accounts",
} as const;
export type Hydrate = ClosedEnum<typeof Hydrate>;

export type ListSchedulesRequest = {
  skip?: number | undefined;
  count?: number | undefined;
  hydrate?: Hydrate | undefined;
  accountID: string;
};

export type ListSchedulesResponse = {
  headers: { [k: string]: Array<string> };
  result: Array<components.ScheduleListResponse>;
};

/** @internal */
export const ListSchedulesGlobals$inboundSchema: z.ZodType<
  ListSchedulesGlobals,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-Moov-Version": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-Moov-Version": "xMoovVersion",
  });
});
/** @internal */
export type ListSchedulesGlobals$Outbound = {
  "X-Moov-Version"?: string | undefined;
};

/** @internal */
export const ListSchedulesGlobals$outboundSchema: z.ZodType<
  ListSchedulesGlobals$Outbound,
  z.ZodTypeDef,
  ListSchedulesGlobals
> = z.object({
  xMoovVersion: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xMoovVersion: "X-Moov-Version",
  });
});

export function listSchedulesGlobalsToJSON(
  listSchedulesGlobals: ListSchedulesGlobals,
): string {
  return JSON.stringify(
    ListSchedulesGlobals$outboundSchema.parse(listSchedulesGlobals),
  );
}
export function listSchedulesGlobalsFromJSON(
  jsonString: string,
): SafeParseResult<ListSchedulesGlobals, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSchedulesGlobals$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSchedulesGlobals' from JSON`,
  );
}

/** @internal */
export const Hydrate$inboundSchema: z.ZodNativeEnum<typeof Hydrate> = z
  .nativeEnum(Hydrate);
/** @internal */
export const Hydrate$outboundSchema: z.ZodNativeEnum<typeof Hydrate> =
  Hydrate$inboundSchema;

/** @internal */
export const ListSchedulesRequest$inboundSchema: z.ZodType<
  ListSchedulesRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  skip: z.number().int().optional(),
  count: z.number().int().optional(),
  hydrate: Hydrate$inboundSchema.optional(),
  accountID: z.string(),
});
/** @internal */
export type ListSchedulesRequest$Outbound = {
  skip?: number | undefined;
  count?: number | undefined;
  hydrate?: string | undefined;
  accountID: string;
};

/** @internal */
export const ListSchedulesRequest$outboundSchema: z.ZodType<
  ListSchedulesRequest$Outbound,
  z.ZodTypeDef,
  ListSchedulesRequest
> = z.object({
  skip: z.number().int().optional(),
  count: z.number().int().optional(),
  hydrate: Hydrate$outboundSchema.optional(),
  accountID: z.string(),
});

export function listSchedulesRequestToJSON(
  listSchedulesRequest: ListSchedulesRequest,
): string {
  return JSON.stringify(
    ListSchedulesRequest$outboundSchema.parse(listSchedulesRequest),
  );
}
export function listSchedulesRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListSchedulesRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSchedulesRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSchedulesRequest' from JSON`,
  );
}

/** @internal */
export const ListSchedulesResponse$inboundSchema: z.ZodType<
  ListSchedulesResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Headers: z.record(z.array(z.string())).default({}),
  Result: z.array(components.ScheduleListResponse$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "Headers": "headers",
    "Result": "result",
  });
});
/** @internal */
export type ListSchedulesResponse$Outbound = {
  Headers: { [k: string]: Array<string> };
  Result: Array<components.ScheduleListResponse$Outbound>;
};

/** @internal */
export const ListSchedulesResponse$outboundSchema: z.ZodType<
  ListSchedulesResponse$Outbound,
  z.ZodTypeDef,
  ListSchedulesResponse
> = z.object({
  headers: z.record(z.array(z.string())),
  result: z.array(components.ScheduleListResponse$outboundSchema),
}).transform((v) => {
  return remap$(v, {
    headers: "Headers",
    result: "Result",
  });
});

export function listSchedulesResponseToJSON(
  listSchedulesResponse: ListSchedulesResponse,
): string {
  return JSON.stringify(
    ListSchedulesResponse$outboundSchema.parse(listSchedulesResponse),
  );
}
export function listSchedulesResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListSchedulesResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSchedulesResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSchedulesResponse' from JSON`,
  );
}
